import { render } from "./MyRecords.vue?vue&type=template&id=ea0ea1f2&scoped=true"
import script from "./MyRecords.vue?vue&type=script&lang=js"
export * from "./MyRecords.vue?vue&type=script&lang=js"

import "./MyRecords.vue?vue&type=style&index=0&id=ea0ea1f2&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea0ea1f2"]])

export default __exports__